import { createContext, useState } from "react";

export const ThemeContext = createContext(null);

export default ({ children }) => {
    // theme should be "primary" for pink and "secondary" for blue
    const [theme,setTheme] = useState("primary");
    return (
        <ThemeContext.Provider value={{theme,setTheme}}>
            {children}
        </ThemeContext.Provider>
    )
}

